export default __webpack_public_path__ + "static/media/ABZ.8af63bc5.jpeg";